import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../../utils/baseQueryFn';


const leaderboardAPI = createApi({
    reducerPath: "leaderboardApi",
    baseQuery,
    endpoints: (builder) => ({
        getLeaderboardList: builder.mutation({
            query: ({page, size, key, driverType, vehicleType, startDate, endDate, onlyBookedDrivers}) => {
                const queryParams = new URLSearchParams({
                    page,
                    size
                });
    
                if (key) {
                    queryParams.append('searchKey', key);
                }

                if (driverType) {
                    queryParams.append('driverType', driverType);
                }

                if (vehicleType) {
                    queryParams.append('vehicleType', vehicleType);
                }

                if (startDate && endDate) {
                    queryParams.append('startDate', startDate);
                    queryParams.append('endDate', endDate);
                }

                if(onlyBookedDrivers){
                    queryParams.append('onlyBookedDrivers', true);
                }
    
                const apiUrl = `leader-board/?${queryParams.toString()}`;

                return{
                    url: apiUrl,
                    method: "GET"
                }
            },
            transformResponse: (response) => {
                const items = response?.data ?? response?.content;

                if (items) {
                    return {
                        ...response,
                        content: items,
                        totalElements: response?.meta?.total ?? response?.totalElements,
                    };
                }
                return response;
            },
        }),
    }),
});

export const { useGetLeaderboardListMutation} = leaderboardAPI;
export default leaderboardAPI;
